import React, { Component } from 'react';

import Defaults from '../../../shared/constants/defaults';
import FormSettings from '../../../shared/constants/form-settings';

import SettingsTab from '../tab';
import NotificationsSection from '../sections/notifications';
import ConfirmationEmailSection from '../sections/confirmation-email';

import classNames from 'classnames';

export default class EmailsTab extends SettingsTab {
	constructor (props) {
		super(props);

		/*
		Sets seed settings for form if navigating to Form Options for a payment form without saving the form first.
		The conditions below are only met under this edge case
		*/
		if (props.formData.collectPayment && (props.formData.settings.stripeAccount && Object.keys(props.formData.settings.stripeAccount).length == 0)) {
			this.updateSetting(FormSettings.SHOW_CONFIRMATION_EMAIL_INPUT, true);
			this.updateSetting(FormSettings.REQUIRE_CONFIRMATION_EMAIL, true);
			this.updateSetting(FormSettings.INCLUDE_RESPONSE_IN_CONFIRMATION, true);
		}
	}
	
	render () {
		let { formData, localization } = this.props;
		
		let classes = classNames({
			'hidden': !this.props.selected
		}, 'emails')

		const formCollectsPayment = this.props.formData.collectPayment ? this.props.formData.collectPayment : null;
		const formCollectsSignature = this.props.formData.collectSignature ? this.props.formData.collectSignature : null;

		return (
			<section className={classes} key={this.props.customKey}>
				<div className='left column'>
					<NotificationsSection
						notificationEmailAddresses={this.coalesceProperty(FormSettings.NOTIFICATION_EMAIL_LIST, [])}
						showConfirmationEmailInput={this.coalesceProperty(FormSettings.SHOW_CONFIRMATION_EMAIL_INPUT, formData.settings.sendConfirmationEmail)}
						requireConfirmationEmail={this.coalesceProperty(FormSettings.REQUIRE_CONFIRMATION_EMAIL, formData.settings.sendConfirmationEmail)}
						includeResponse={this.coalesceProperty(FormSettings.INCLUDE_RESPONSE_IN_ADMIN_DIGEST)}
						updateCallback={this.updateSetting}
						localization={localization}
					/>
				</div>
				<div className='right column'>
					{/*
						Properties 'showConfirmationEmailInput' & 'requireConfirmationEmail'
						are coalesced with 'sendConfirmationEmail' because while
						'sendConfirmationEmail' is deprecated, it may still be present
						in older forms.
					*/}
					<ConfirmationEmailSection
						showConfirmationEmailInput={this.coalesceProperty(FormSettings.SHOW_CONFIRMATION_EMAIL_INPUT, formData.settings.sendConfirmationEmail)}
						requireConfirmationEmail={this.coalesceProperty(FormSettings.REQUIRE_CONFIRMATION_EMAIL, false)}
						includeResponseInConfirmationEmail={this.coalesceProperty(FormSettings.INCLUDE_RESPONSE_IN_CONFIRMATION)}
						confirmationEmailContent={this.coalesceProperty(FormSettings.CONFIRMATION_EMAIL_CUSTOM_CONTENT, formCollectsSignature ? Defaults.SUBMISSION_EMAIL_CONFIRMATION_MESSAGE : Defaults.CONFIRMATION_MESSAGE)}
						updateCallback={this.updateSetting}
						localization={localization}
                        formCollectsPayment={formCollectsPayment}
						formCollectsSignature={formCollectsSignature}
					/>
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/tabs/emails.js